import React, { useCallback, useEffect, useState } from 'react';
import { useAppState } from '../context/State';
import VideoCarouselCard from './VideoCarouselCard';
import { GetCopy } from '../util/GetCopy';
import { useInView } from 'react-intersection-observer';

const VideoCarousel = ({ selectedFormat }) => {
  const state = useAppState();
  const adData = state.adData;
  const videoData = state.videoData;

  const selectedOption = state.activeOption;
  const [filteredData, setFilteredData] = useState([]);
  const activeOption = state.activeOption;
  const [visibleAdData, setVisibleAdData] = useState([...adData.slice(0, 0 + 9)]);

  const loadMoreAds = () => {
    setVisibleAdData((prevData) => {
      const newIndex = prevData.length;
      return [...prevData, ...filteredData.slice(newIndex, newIndex + 9)];
    });
  };

  const LoadMoreButtonComponent = () => {
    const { ref, inView } = useInView({
      // Triggered when 50% of element is visible
      threshold: 0.5,
    });
    const debounce = (func, delay) => {
      let timer;
      return () => {
        clearTimeout(timer);
        timer = setTimeout(() => {
          func();
        }, delay);
      };
    };

    const handleInView = useCallback(
      debounce(() => {
        loadMoreAds();
      }, 100), // 300ms delay
      [], // dependencies
    );

    useEffect(() => {
      if (visibleAdData.length < filteredData.length && inView) {
        handleInView();
      }
    }, [inView, handleInView]);

    return (
      (visibleAdData.length < filteredData.length && (
        <button ref={ref} className="loadMoreButton" onClick={loadMoreAds}>
          <span className="mb-3">
            <GetCopy copy="load more" />
          </span>
        </button>
      )) ||
      null
    );
  };
  useEffect(() => {
    if (selectedOption === 'Display') {
      const dataToFilter = adData;
      const dt = dataToFilter.filter((item) => {
        const formatField = item.custom_fields.find((f) => f.name === 'Format');
        const format = formatField?.type_config?.options?.[formatField?.value]?.name;

        if (selectedFormat === 'All') return true; // If 'All' is selected, show all formats
        if (format) {
          return format === selectedFormat;
        }
        return false;
      });
      setFilteredData(dt);
      setVisibleAdData([...dt.slice(0, 0 + 9)]);
    }
  }, [selectedFormat, adData, videoData, selectedOption]);

  useEffect(() => {
    if (selectedOption === 'Video') {
      const dataToFilter = videoData;
      const dt = dataToFilter.filter((item) => {
        const formatField = item.custom_fields.find((f) => f.name === 'Format');
        const format = formatField?.type_config?.options?.[formatField?.value]?.name;
        if (selectedFormat === 'All') return true; // If 'All' is selected, show all formats
        if (format) {
          return format === selectedFormat;
        }
        return false;
      });
      setFilteredData(dt);
    }
  }, [selectedFormat, adData, videoData, selectedOption]);

  if (!state || !adData) return 'Loading...';
  const dataToPreview = selectedOption === 'Video' ? filteredData : visibleAdData;

  return (
    <div style={{ width: '100%', overflow: 'hidden' }}>
      <div className="row">
        <div className="container displayContainer  flex-row flex-wrap">
          {dataToPreview.map((item, index) => {
            const fieldMap = {
              name: item.name,
              ...Object.fromEntries(item.custom_fields.map((f) => [f.name, f.value])),
            };
            if (fieldMap.Live) {
              return <VideoCarouselCard item={fieldMap} key={index} index={index} activeOption={activeOption} />;
            }
            return null;
          })}
        </div>
      </div>
      <LoadMoreButtonComponent />
    </div>
  );
};

export default VideoCarousel;
